import { Link } from "react-router-dom";
import { useLang } from "../../lib/i18n";

export const ConsentBox = ({ checked, onChange, children, testid }) => (
  <label className="flex cursor-pointer items-start gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm leading-relaxed text-slate-600" data-testid={`${testid}-label`}>
    <input type="checkbox" required checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 accent-[#FF5722]" data-testid={testid} />
    <span>{children}</span>
  </label>
);

export const PrivacyConsent = ({ checked, onChange }) => {
  const { t } = useLang();
  return (
    <ConsentBox checked={checked} onChange={onChange} testid="consent-privacy">
      {t("consent_privacy")} <Link to="/privacy" target="_blank" className="font-semibold text-[#FF5722] underline" data-testid="consent-privacy-link">{t("privacy_policy")}</Link> *
    </ConsentBox>
  );
};

export const GuardianConsent = ({ checked, onChange }) => {
  const { t } = useLang();
  return <ConsentBox checked={checked} onChange={onChange} testid="consent-guardian">{t("consent_guardian")} *</ConsentBox>;
};
